import {
  FunnelStageData,
  OfficerData,
  LeadData,
  OpportunityData,
  SourceBreakdownData,
} from './types'

export const funnelData: FunnelStageData[] = [
  { id: 'created', name: 'Created', count: 1991, percentage: 100 },
  {
    id: 'converted',
    name: 'Converted',
    count: 684,
    percentage: 34,
    dropoff: 34,
  },
  {
    id: 'disc_sent',
    name: 'Disc. Sent',
    count: 245,
    percentage: 12,
    dropoff: 36,
  },
  {
    id: 'disc_received',
    name: 'Disc. Received',
    count: 212,
    percentage: 11,
    dropoff: 87,
  },
  { id: 'sub_uw', name: 'Sub. UW', count: 193, percentage: 10, dropoff: 91 },
  {
    id: 'awc',
    name: 'Appr. w/ Conditions',
    count: 155,
    percentage: 8,
    dropoff: 80,
  },
  { id: 'ctc', name: 'CTC', count: 41, percentage: 2, dropoff: 27 },
  { id: 'funded', name: 'Funded', count: 11, percentage: 1, dropoff: 27 },
]

export const officerData: OfficerData[] = [
  {
    id: '1',
    name: 'Cole Duran',
    status: 'Active',
    created: 11,
    converted: 11,
    discSent: 7,
    subUw: 5,
    awc: 5,
    funded: 2,
    pullThrough: 18,
  },
  {
    id: '2',
    name: 'John Kassab',
    status: 'Active',
    created: 35,
    converted: 34,
    discSent: 19,
    subUw: 19,
    awc: 18,
    funded: 2,
    pullThrough: 6,
  },
  {
    id: '3',
    name: 'Albert Barton',
    status: 'Active',
    created: 5,
    converted: 5,
    discSent: 4,
    subUw: 1,
    awc: 1,
    funded: 1,
    pullThrough: 20,
  },
  {
    id: '4',
    name: 'Alex Ibrahim',
    status: 'Active',
    created: 67,
    converted: 11,
    discSent: 8,
    subUw: 8,
    awc: 7,
    funded: 1,
    pullThrough: 2,
  },
  {
    id: '5',
    name: 'Christina Palmer',
    status: 'Active',
    created: 21,
    converted: 16,
    discSent: 6,
    subUw: 6,
    awc: 5,
    funded: 1,
    pullThrough: 5,
  },
  {
    id: '6',
    name: 'Dahmir Farnum',
    status: 'Active',
    created: 9,
    converted: 9,
    discSent: 4,
    subUw: 4,
    awc: 2,
    funded: 1,
    pullThrough: 11,
  },
  {
    id: '7',
    name: 'Inkka Theodoroes',
    status: 'Active',
    created: 27,
    converted: 27,
    discSent: 13,
    subUw: 11,
    awc: 9,
    funded: 1,
    pullThrough: 4,
  },
  {
    id: '8',
    name: 'Sal Consiglio',
    status: 'Active',
    created: 15,
    converted: 7,
    discSent: 2,
    subUw: 2,
    awc: 2,
    funded: 1,
    pullThrough: 7,
  },
  {
    id: '9',
    name: 'Torrie Hill',
    status: 'Active',
    created: 39,
    converted: 16,
    discSent: 6,
    subUw: 4,
    awc: 4,
    funded: 1,
    pullThrough: 3,
  },
  {
    id: '10',
    name: 'Abdullah Alata',
    status: 'Active',
    created: 17,
    converted: 16,
    discSent: 2,
    subUw: 2,
    awc: 0,
    funded: 0,
    pullThrough: 0,
  },
  {
    id: '11',
    name: 'Adam James',
    status: 'Active',
    created: 8,
    converted: 3,
    discSent: 0,
    subUw: 0,
    awc: 0,
    funded: 0,
    pullThrough: 0,
  },
  {
    id: '12',
    name: 'Ahmed Rustom',
    status: 'Active',
    created: 14,
    converted: 14,
    discSent: 1,
    subUw: 1,
    awc: 1,
    funded: 0,
    pullThrough: 0,
  },
  {
    id: '13',
    name: 'Alan Shlaimon',
    status: 'Active',
    created: 30,
    converted: 12,
    discSent: 8,
    subUw: 5,
    awc: 5,
    funded: 0,
    pullThrough: 0,
  },
  {
    id: '14',
    name: 'Ali Almansori',
    status: 'Active',
    created: 26,
    converted: 26,
    discSent: 4,
    subUw: 3,
    awc: 3,
    funded: 0,
    pullThrough: 0,
  },
  {
    id: '15',
    name: 'Ali Baidoun',
    status: 'Active',
    created: 27,
    converted: 24,
    discSent: 5,
    subUw: 4,
    awc: 2,
    funded: 0,
    pullThrough: 0,
  },
  {
    id: '16',
    name: 'Amelio Zaya',
    status: 'Active',
    created: 25,
    converted: 24,
    discSent: 15,
    subUw: 14,
    awc: 13,
    funded: 0,
    pullThrough: 0,
  },
]

export const mockLeads: LeadData[] = [
  {
    id: 'l1',
    name: 'Ronald Kinnas Jr.',
    source: 'Other',
    created: 'Apr 29, 2026',
    status: 'Open',
  },
  {
    id: 'l2',
    name: 'Phillip Luttrell',
    source: 'Other',
    created: 'Apr 28, 2026',
    status: 'Open',
  },
  {
    id: 'l3',
    name: 'Lairtoya Mcnealy-Carrillo',
    source: 'Other',
    created: 'Apr 28, 2026',
    status: 'Open',
  },
  {
    id: 'l4',
    name: 'Glenn Betournay',
    source: 'Other',
    created: 'Apr 28, 2026',
    status: 'Open',
  },
  {
    id: 'l5',
    name: 'Donell Clay',
    source: 'Other',
    created: 'Apr 27, 2026',
    status: 'Open',
  },
  {
    id: 'l6',
    name: 'TYKEIM KOONCE DIXON',
    source: 'Other',
    created: 'Apr 27, 2026',
    status: 'Open',
  },
  {
    id: 'l7',
    name: 'Charles Frazier',
    source: 'Other',
    created: 'Apr 27, 2026',
    status: 'Open',
  },
]

export const mockOpportunities: OpportunityData[] = [
  {
    id: 'o1',
    name: 'Erica Robinson - 1526160791',
    stage: 'Funded',
    amount: 141700,
    converted: 'Mar 31, 2026',
    funded: 'Apr 28, 2026',
  },
  {
    id: 'o2',
    name: 'Christopher Cotter - 1526161865',
    stage: 'Funded',
    amount: 459260,
    converted: 'Apr 1, 2026',
    funded: 'Apr 27, 2026',
  },
  {
    id: 'o3',
    name: 'COLE MWENDAFILUMBA - 1526163542',
    stage: 'Funded',
    amount: 288053,
    converted: 'Apr 6, 2026',
    funded: 'Apr 27, 2026',
  },
  {
    id: 'o4',
    name: 'Jesse Meers - 1526157602',
    stage: 'Funded',
    amount: 208430,
    converted: 'Apr 1, 2026',
    funded: 'Apr 26, 2026',
  },
  {
    id: 'o5',
    name: 'Michael Harmon - 1526166616',
    stage: 'Funded',
    amount: 219800,
    converted: 'Apr 8, 2026',
    funded: 'Apr 26, 2026',
  },
  {
    id: 'o6',
    name: 'Fred Keith - 1526157881',
    stage: 'Funded',
    amount: 264400,
    converted: 'Apr 2, 2026',
    funded: 'Apr 23, 2026',
  },
  {
    id: 'o7',
    name: 'Jordan Goodin - 1526162202',
    stage: 'Funded',
    amount: 195550,
    converted: 'Apr 5, 2026',
    funded: 'Apr 21, 2026',
  },
]

export const sourceBreakdownData: SourceBreakdownData[] = [
  {
    id: 's1',
    source: 'Zillow',
    color: '#5a7fa5',
    created: 842,
    converted: 218,
    funded: 14,
    convRate: 25.9,
    pullThrough: 1.7,
    createdAmount: 235760000,
    convertedAmount: 61040000,
    fundedAmount: 3654000,
    avgAmount: 261000,
  },
  {
    id: 's2',
    source: 'LendingTree',
    color: '#c9a84c',
    created: 612,
    converted: 134,
    funded: 9,
    convRate: 21.9,
    pullThrough: 1.5,
    createdAmount: 174420000,
    convertedAmount: 38190000,
    fundedAmount: 2295000,
    avgAmount: 255000,
  },
  {
    id: 's3',
    source: 'Realtor Partner',
    color: '#3d3d3d',
    created: 198,
    converted: 142,
    funded: 22,
    convRate: 71.7,
    pullThrough: 11.1,
    createdAmount: 65340000,
    convertedAmount: 46860000,
    fundedAmount: 7260000,
    avgAmount: 330000,
  },
  {
    id: 's4',
    source: 'Past Client',
    color: '#22c55e',
    created: 76,
    converted: 71,
    funded: 19,
    convRate: 93.4,
    pullThrough: 25.0,
    createdAmount: 22800000,
    convertedAmount: 21300000,
    fundedAmount: 5700000,
    avgAmount: 300000,
  },
  {
    id: 's5',
    source: 'Website',
    color: '#8b5cf6',
    created: 154,
    converted: 56,
    funded: 5,
    convRate: 36.4,
    pullThrough: 3.2,
    createdAmount: 42350000,
    convertedAmount: 15400000,
    fundedAmount: 1375000,
    avgAmount: 275000,
  },
  {
    id: 's6',
    source: 'Social Media',
    color: '#ec4899',
    created: 88,
    converted: 24,
    funded: 2,
    convRate: 27.3,
    pullThrough: 2.3,
    createdAmount: 21560000,
    convertedAmount: 5880000,
    fundedAmount: 490000,
    avgAmount: 245000,
  },
  {
    id: 's7',
    source: 'Inbound Call',
    color: '#0ea5e9',
    created: 47,
    converted: 38,
    funded: 6,
    convRate: 80.9,
    pullThrough: 12.8,
    createdAmount: 14570000,
    convertedAmount: 11780000,
    fundedAmount: 1860000,
    avgAmount: 310000,
  },
  {
    id: 's8',
    source: 'Other',
    color: '#6b7280',
    created: 35,
    converted: 9,
    funded: 1,
    convRate: 25.7,
    pullThrough: 2.9,
    createdAmount: 9100000,
    convertedAmount: 2340000,
    fundedAmount: 260000,
    avgAmount: 260000,
  },
]

// =====================================================
// FILTER LOGIC
// =====================================================
export type DateRangeKey = '7d' | '30d' | '90d' | 'ytd' | 'all'

export const dateRangeOptions: { key: DateRangeKey; label: string }[] = [
  { key: '7d', label: 'Last 7 days' },
  { key: '30d', label: 'Last 30 days' },
  { key: '90d', label: 'Last 90 days' },
  { key: 'ytd', label: 'Year to date' },
  { key: 'all', label: 'All time' },
]

const dateScaleFactors: Record<DateRangeKey, number> = {
  '7d': 0.23,
  '30d': 1.0,
  '90d': 2.85,
  ytd: 4.5,
  all: 5.5,
}

const scopeScaleFactors: Record<string, number> = {
  'All Loan Officers': 1.0,
  'By SVP': 0.55,
  'By Team Lead': 0.3,
  'Single Officer': 0.05,
}

export interface FilterState {
  dateRangeKey: DateRangeKey
  scope: string
  sources: string[] // empty = all
  stages: string[] // empty = all (funnel stage ids)
  includeInactive: boolean
}

// Selectable loan stages for the filter (later-pipeline focus)
export const loanStageOptions: { id: string; label: string }[] = [
  { id: 'disc_sent', label: 'Disclosures Sent' },
  { id: 'disc_received', label: 'Disclosures Received' },
  { id: 'sub_uw', label: 'Submitted to UW' },
  { id: 'awc', label: 'AWC' },
  { id: 'ctc', label: 'CTC' },
  { id: 'funded', label: 'Funded' },
]

export interface FilteredDataset {
  funnel: FunnelStageData[]
  officers: OfficerData[]
  sources: SourceBreakdownData[]
  kpis: {
    created: number
    converted: number
    funded: number
    pullThrough: number
    avgCycleDays: number
  }
}

export function applyFilters(filters: FilterState): FilteredDataset {
  const dateFactor = dateScaleFactors[filters.dateRangeKey] ?? 1
  const scopeFactor = scopeScaleFactors[filters.scope] ?? 1

  // ---- Source filter ----
  const sourcesActive = filters.sources.length > 0
  const filteredSources = sourcesActive
    ? sourceBreakdownData.filter((s) => filters.sources.includes(s.source))
    : sourceBreakdownData

  // Compute share of Created represented by selected sources
  const totalCreatedAllSources = sourceBreakdownData.reduce(
    (sum, s) => sum + s.created,
    0,
  )
  const selectedCreated = filteredSources.reduce((sum, s) => sum + s.created, 0)
  const sourceShare =
    totalCreatedAllSources > 0 ? selectedCreated / totalCreatedAllSources : 1

  // ---- Stage filter ----
  // When stages are selected, scope the cohort to opportunities currently at those stages.
  const stagesActive = filters.stages.length > 0
  const baseCreatedAll = funnelData[0].count
  const selectedStageCount = stagesActive
    ? funnelData
        .filter((s) => filters.stages.includes(s.id))
        .reduce((sum, s) => sum + s.count, 0)
    : baseCreatedAll
  const stageShare =
    baseCreatedAll > 0 ? selectedStageCount / baseCreatedAll : 1

  // ---- Combined multiplier ----
  const totalMultiplier = dateFactor * scopeFactor * sourceShare * stageShare

  // ---- Scale source rows by date * scope * stage share ----
  const dsMultiplier = dateFactor * scopeFactor * stageShare
  const scaledSources: SourceBreakdownData[] = filteredSources.map((s) => ({
    ...s,
    created: Math.round(s.created * dsMultiplier),
    converted: Math.round(s.converted * dsMultiplier),
    funded: Math.round(s.funded * dsMultiplier),
    createdAmount: Math.round(s.createdAmount * dsMultiplier),
    convertedAmount: Math.round(s.convertedAmount * dsMultiplier),
    fundedAmount: Math.round(s.fundedAmount * dsMultiplier),
  }))

  // ---- Scale funnel by total multiplier ----
  const baseCreated = funnelData[0].count
  const scaledFunnel: FunnelStageData[] = funnelData.map((stage) => {
    const newCount = Math.max(0, Math.round(stage.count * totalMultiplier))
    const newPct =
      baseCreated > 0
        ? Math.round(
            (newCount /
              Math.max(1, Math.round(baseCreated * totalMultiplier))) *
              100,
          )
        : 0
    return {
      ...stage,
      count: newCount,
      percentage: newPct,
    }
  })

  // Recompute dropoff between stages
  for (let i = 1; i < scaledFunnel.length; i++) {
    const prev = scaledFunnel[i - 1].count
    const curr = scaledFunnel[i].count
    scaledFunnel[i] = {
      ...scaledFunnel[i],
      dropoff: prev > 0 ? Math.round((curr / prev) * 100) : 0,
    }
  }

  // ---- Scale officers ----
  let scaledOfficers: OfficerData[] = officerData.map((o) => {
    const newCreated = Math.round(o.created * totalMultiplier)
    const newConverted = Math.round(o.converted * totalMultiplier)
    const newDiscSent = Math.round(o.discSent * totalMultiplier)
    const newSubUw = Math.round(o.subUw * totalMultiplier)
    const newAwc = Math.round(o.awc * totalMultiplier)
    const newFunded = Math.round(o.funded * totalMultiplier)
    return {
      ...o,
      created: newCreated,
      converted: newConverted,
      discSent: newDiscSent,
      subUw: newSubUw,
      awc: newAwc,
      funded: newFunded,
      pullThrough:
        newCreated > 0
          ? Math.round((newFunded / newCreated) * 100 * 10) / 10
          : 0,
    }
  })

  // Scope filter: Single Officer = show just 1 representative officer
  if (filters.scope === 'Single Officer') {
    scaledOfficers = scaledOfficers.slice(0, 1)
  } else if (filters.scope === 'By Team Lead') {
    scaledOfficers = scaledOfficers.slice(0, 5)
  } else if (filters.scope === 'By SVP') {
    scaledOfficers = scaledOfficers.slice(0, 9)
  }

  // Include inactive filter (currently all officers are Active in mock — preserve)
  if (!filters.includeInactive) {
    scaledOfficers = scaledOfficers.filter((o) => o.status === 'Active')
  }

  // ---- KPIs derived from scaled funnel ----
  const created = scaledFunnel[0]?.count ?? 0
  const converted = scaledFunnel[1]?.count ?? 0
  const funded = scaledFunnel[scaledFunnel.length - 1]?.count ?? 0
  const pullThrough =
    created > 0 ? Math.round((funded / created) * 100 * 10) / 10 : 0

  return {
    funnel: scaledFunnel,
    officers: scaledOfficers,
    sources: scaledSources,
    kpis: {
      created,
      converted,
      funded,
      pullThrough,
      avgCycleDays: 19,
    },
  }
}
